import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import { routes as captainRoutes } from './captain/captain.routes';
// NOTICE: KAPTION-INTEGRATION
import { routes as playgroundRoutes } from './playground/playground.routes';
import { routes as aiStudioRoutes } from './ai-studio/ai-studio.routes';
import { routes as kaptionDebugRoutes } from './kaption-debug/kaption-debug.routes';
// NOTICE: KAPTION-INTEGRATION - team-location.UI.1
import { routes as kaptionTeamLocationRoutes } from './kaptionTeamLocation/kaptionTeamLocation.routes';
// NOTICE: KAPTION-INTEGRATION - app-studio.UI.1 / PLACEMENTS.5: Rumo Builder
import { routes as kaptionAppStudioRoutes } from './kaptionAppStudio/kaptionAppStudio.routes';
// NOTICE: KAPTION-INTEGRATION - whatsapp-calling.WEB.3: Calls workspace
import { routes as kaptionCallsRoutes } from './kaptionCalls/kaptionCalls.routes';
// NOTICE: KAPTION-INTEGRATION - whatsapp-flows: Flows library
import { routes as kaptionWhatsappFlowsRoutes } from './kaptionWhatsappFlows/kaptionWhatsappFlows.routes';
// NOTICE: KAPTION-INTEGRATION - Asistentes (agent providers)
import { routes as kaptionAssistantsRoutes } from './kaptionAssistants/kaptionAssistants.routes';
// NOTICE: KAPTION-INTEGRATION - Partner panel (partner-provisioning.PORTAL.6):
// account-less, outside the conversational shell.
import { routes as kaptionPartnerRoutes } from './kaptionPartner/kaptionPartner.routes';
// NOTICE: KAPTION-INTEGRATION - Full-screen dashboard apps
import { routes as fullscreenAppRoutes } from './fullscreen-app/fullscreen-app.routes';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
// NOTICE: KAPTION-INTEGRATION - Rumo MCP OAuth consent page
// NOTICE: KAPTION-INTEGRATION - ai-connectors.FLAG.1: the gate picks the new or legacy consent page
import KaptionMcpAuthorize from './kaptionMcpAuthorize/KaptionMcpAuthorizeGate.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...captainRoutes,
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
        // NOTICE: KAPTION-INTEGRATION
        ...playgroundRoutes,
        ...aiStudioRoutes,
        ...kaptionDebugRoutes,
        // NOTICE: KAPTION-INTEGRATION - team-location.UI.1
        ...kaptionTeamLocationRoutes,
        // NOTICE: KAPTION-INTEGRATION - app-studio.UI.1 / PLACEMENTS.5
        ...kaptionAppStudioRoutes,
        // NOTICE: KAPTION-INTEGRATION - whatsapp-calling.WEB.3
        ...kaptionCallsRoutes,
        // NOTICE: KAPTION-INTEGRATION - whatsapp-flows
        ...kaptionWhatsappFlowsRoutes,
        // NOTICE: KAPTION-INTEGRATION - Asistentes (agent providers)
        ...kaptionAssistantsRoutes,
        ...fullscreenAppRoutes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    // NOTICE: KAPTION-INTEGRATION
    // Partner panel: authenticated but account-less, with its own chrome. A
    // partner staffer may hold no account at all.
    ...kaptionPartnerRoutes,
    // NOTICE: KAPTION-INTEGRATION
    // OAuth consent page for the Rumo MCP. Authenticated but account-less —
    // the workspace is picked inside the page (see routeHelpers.js skip).
    {
      path: frontendURL('mcp-authorize'),
      name: 'kaption_mcp_authorize',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: KaptionMcpAuthorize,
    },
  ],
};
